import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { IconNames } from '../../../../common';
import { ValidationService } from '../../../../common/services/validation.service';
import { ProfileType } from '../../../../store/constants';

@Component({
  selector: 'ui-monitoring-profile-settings',
  templateUrl: './monitoring-profile-settings.component.html',
  styleUrls: ['./monitoring-profile-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MonitoringProfileSettingsComponent {
  @Input() set form(form: UntypedFormGroup) {
    if (form) {
      this.initProfileForm(form);
    }
  }
  @Input() isUserProfileCreator: boolean;
  @Input() isCloned: boolean;
  @Input() isProfileDetailsDisabled: boolean;

  profileForm: UntypedFormGroup;
  monitoringProfileType = ProfileType;
  iconNameList = IconNames;

  constructor(public validationService: ValidationService) {}

  private initProfileForm(form: UntypedFormGroup): void {
    this.profileForm = form;
  }
}
